export default __webpack_public_path__ + "static/media/flag_ja.fdbc8bce.svg";